<template>
  <MainLogin :title="'GeoVisor'">
    <div v-if="!checkChrome" class="text-center mb-3">
      <h4 style="color:#c01313;">Su navegador no es compatible con GeoVisor.</h4>
      <h4 style="color:#c01313;"><b>Utilice Chrome</b> para acceder a la aplicación</h4>
    </div>
    <div v-if="!loading">
      <div v-if="!useEntraInsteadOfUsrAndPwd">
        <b-form-group
          :class="{feedback : errors.has('Código de usuario')}"
          :label="'Código de usuario:'"
          :label-for="'Código de usuario'">
          <b-form-input :type="type" :name="'Código de usuario'" :id="'Código de usuario'" v-model="value_field"
                        v-validate="'required'"></b-form-input>
          <transition name="slide-down">
            <p v-show="errors.has('Código de usuario')" class="alert alert-danger feedback-message">
              {{ errors.first('Código de usuario') }}
            </p>
          </transition>
        </b-form-group>

        <b-form-group
          :class="{feedback : errors.has('contraseña')}"
          label="Contraseña:"
          label-for="contraseña">
          <b-form-input type="password" name="contraseña" class="form-control" id="pwd" v-model="password"
                        v-validate="'required'"></b-form-input>
          <transition name="slide-down">
            <p v-show="errors.has('contraseña')" class="alert alert-danger feedback-message">
              {{ errors.first('contraseña') }}
            </p>
          </transition>
          <transition name="slide-down">
            <p v-show="errors.has('bot')" class="alert alert-danger feedback-message">
              {{ errors.first('bot') }}
            </p>
          </transition>
        </b-form-group>
      </div>
      <b-row>
        <b-col>
          <div>
            <Recaptcha v-if="!logged" @validate="validate"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <template v-if="!useEntraInsteadOfUsrAndPwd">
          <b-col lg="4">
            <b-btn
              block
              :disabled="!this.validateRecaptcha"
              id="login-button"
              variant="primary"
              @click="login">
              Entrar <i v-if="this.validateRecaptcha" class="fa fa-sign-in"></i><i v-if="!this.validateRecaptcha" class="fa fa-lock"></i>
            </b-btn>
          </b-col>
          <b-col lg="8" class="text-right">
            <b-link v-if="manageUs === true" @click="resetPassword">¿Has olvidado la contraseña?</b-link>
          </b-col>
        </template>
        <template v-else>
          <b-col>
            <b-btn
              block
              :disabled="!this.validateRecaptcha"
              id="signInEntra-button"
              variant="primary"
              @click="signIn">
              Entrar con Microsoft<i v-if="this.validateRecaptcha" class="fa fa-sign-in"></i><i v-if="!this.validateRecaptcha" class="fa fa-lock"></i>
            </b-btn>
            <transition name="slide-down">
              <p v-show="errors.has('bot')" class="alert alert-danger feedback-message">
                {{ errors.first('bot') }}
              </p>
            </transition>
          </b-col>
        </template>
      </b-row>

    </div>
    <div v-else class="card-body text-center">
      <p><i class="fa fa-spinner fa-spin fa-3x"></i></p>
      <p>{{ $t('labels.loading') }}</p>
    </div>
  </MainLogin>
</template>

<script>
import MainLogin from './MainLogin';
import Recaptcha from './Recaptcha';
import RecaptchaUtils from '../../utils/recaptcha.utils';
import { PublicClientApplication } from '@azure/msal-browser';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'Login',
  components: {
    MainLogin,
    Recaptcha
  },
  data: function () {
    return {
      field: '',
      value_field: '',
      password: '',
      entraIdToken: '',
      loading: false,
      manageUs: null,
      validateRecaptcha: false,
      logged: false
    };
  },
  computed: {
    type () {
      if (this.field === 'email') {
        return 'email';
      } else {
        return 'text';
      }
    },
    capitalizedField () {
      return this.field.charAt(0).toUpperCase() + this.field.slice(1);
    },
    checkChrome () {
      // return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) -> It only works on PC, not on mobile or tablets
      return navigator.appVersion.indexOf('Chrome/') > -1;
    },
    useEntraInsteadOfUsrAndPwd () {
      // Mira si se ha configurado AUTH_MODE='ENTRA', o si hemos forzado una cookie para forzar ENTRA,
      // desde la consola de DevTools, con algo como:
      //        document.cookie = "useEntraForzadoPorCookie=1; max-age=60; path=/";
      const useEntraForzadoPorCookie = this.getCookie('useEntraForzadoPorCookie');
      return (process.env.AUTH_MODE === 'ENTRA') || (useEntraForzadoPorCookie && useEntraForzadoPorCookie !== '0');
    },
    msalConfig () {
      return {
        auth: {
          clientId: process.env.ENTRA_CLIENT_ID,
          authority: process.env.ENTRA_AUTHORITY,
          redirectUri: process.env.ENTRA_REDIRECT_URI, // must match Azure app registration
          knownAuthorities: ['login.microsoftonline.com']
        }
      };
    }
  },
  methods: {
    getCookie: function (nombre) {
      const valor = `; ${document.cookie}`;
      const partes = valor.split(`; ${nombre}=`);
      if (partes.length === 2) return partes.pop().split(';').shift();
      return null;
    },
    recaptcha: function () {
      RecaptchaUtils.checkRecaptcha.bind(this)('login').then(validRecaptcha => {
        if (validRecaptcha) {
          this.login();
        } else {
          this.errors.add('bot', 'No se cumplen los requisitos para iniciar sesión');
        }
      }, reason => {
        this.errors.add('bot', 'Error validando recaptcha');
      });
    },
    validate (success) {
      this.validateRecaptcha = success;
      this.logged = true;
    },
    signIn: async function () {
      const loginRequest = {
        scopes: ['User.Read']
      };
      try {
        this.errors.clear();
        const msalInstance = new PublicClientApplication(this.msalConfig);
        const response = await msalInstance.loginPopup(loginRequest);
        this.entraIdToken = response.idToken;
        const { name, preferred_username: preferredUsername } = response.idTokenClaims;
        const fullName = name;
        const email = preferredUsername;

        console.log('Id Token:', this.entraIdToken);
        console.log('Full Name:', fullName);
        console.log('Email:', email);

        const username = email.split('@')[0];
        this.internalDoLogin(username, this.entraIdToken, 'ENTRA');
      } catch (error) {
        console.error('Login failed', error);
        this.errors.add('bot', 'Login failed: ' + error);
      }
    },
    internalDoLogin: function (username, pwdOrEntraIdToken, discriminator) {
      var data = {};
      data[this.field] = username;
      data['password'] = `[${discriminator}]${pwdOrEntraIdToken}`;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          this.$http.post('auth/token/create/', data).then(response => {
            var token = response.data['auth_token'];
            document.cookie = 'kernel_token=' + token + ';path=/';
            // this.$parent.logged = true
            document.location.replace('/');
            this.errors.clear();
          }, response => {
            if (discriminator === 'ENTRA') {
              var errMsg = 'Error: El usuario no tiene permisos para usar la aplicación.';
              try {
                var detErrs = response.body.invalid_params.non_field_errors;
                if (detErrs.length > 0) {
                  errMsg += ' (' + detErrs[0] + ')';
                }
              } catch (e) {
              }
              this.errors.add('bot', errMsg);
            } else {
              this.errors.add('contraseña', 'Credenciales incorrectas');
            }
            this.loading = false;
          });
        } else {
          // alert('Login failed, check the errors')
        }
      });
    },
    login: function () {
      this.internalDoLogin(this.value_field, this.password, 'PWD');
    },
    resetPassword: function () {
      this.$router.push({name: 'EmailResetPwd'});
    }
  },
  beforeCreate: function () {
    this.$http.get('check_login/').then(response => {
      this.manageUs = response.data.res;
      this.field = response.data.field;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Login/Login.vue